export function LogoMark({ className = "h-10 w-10" }) {
  return <img src="/brand/logo-sm.png" alt="Trippy Tastic logo" className={`${className} rounded-full shrink-0`} />;
}

export function Logo({ light = false }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <LogoMark />
      <span className={`font-display font-extrabold text-xl tracking-tight leading-none ${light ? "text-cream" : "text-ink"}`}>
        Trippy<span className={`font-serif italic font-normal ml-0.5 ${light ? "text-cream" : "text-ink"}`}>Tastic</span>
      </span>
    </span>
  );
}
